import axios from 'axios';
const API_URL = import.meta.env.VITE_BACKEND_URL;

export const shopifyApi = {
  // Content
  getContent: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/content`);
    return response.data;
  },
  syncContent: async () => {
    const response = await axios.post(`${API_URL}/api/shopify/content/sync`);
    return response.data;
  },
  searchContent: async (query) => {
    const response = await axios.get(`${API_URL}/api/shopify/content/search`, { params: { query } });
    return response.data;
  },
  getContentByType: async (contentType) => {
    const response = await axios.get(`${API_URL}/api/shopify/content/type/${contentType}`);
    return response.data;
  },

  // Products
  getProducts: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/products`);
    return response.data;
  },
  getProductAnalytics: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/products/analytics`);
    return response.data;
  },
  syncProducts: async () => {
    const response = await axios.post(`${API_URL}/api/shopify/products/sync`);
    return response.data;
  },
  getProduct: async (productId) => {
    const response = await axios.get(`${API_URL}/api/shopify/products/${productId}`);
    return response.data;
  },

  // Customers   requries timestamp (startDate, endDate)
  getCustomers: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/customers`);
    return response.data;
  },
  syncCustomers: async () => {
    const response = await axios.post(`${API_URL}/api/shopify/customers/sync`);
    return response.data;
  },
  getCustomerSegments: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/customers/segments`);
    return response.data;
  },

  // Inventory
  getInventory: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/inventory`);
    return response.data;
  },
  // getLocations: async () => {
  //   const response = await axios.get(`${API_URL}/api/shopify/inventory/locations`);
  //   return response.data;
  // },
  syncInventory: async () => {
    const response = await axios.post(`${API_URL}/api/shopify/inventory/sync`);
    return response.data;
  },

  // Marketing  requries timestamp (startDate, endDate)
  getMarketing: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/marketing`);
    return response.data;
  },
  syncMarketing: async () => {
    const response = await axios.post(`${API_URL}/api/shopify/marketing/sync`);
    return response.data;
  },
  getTimeline: async () => { //requries timestamp (startDate, endDate)
    const response = await axios.get(`${API_URL}/api/shopify/marketing/timeline`);
    return response.data;
  },

  // Orders
  getOrders: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/orders`);
    return response.data;
  },
  syncOrders: async () => {
    const response = await axios.post(`${API_URL}/api/shopify/orders/sync`);
    return response.data;
  },
  getOrderDetails: async (orderId) => {
    const response = await axios.get(`${API_URL}/api/shopify/orders/${orderId}`);
    return response.data;
  },

  // Payments ----- pending
  getPayments: async () => {
    const response = await axios.get(`${API_URL}/api/shopify/payments`);
    return response.data;
  },
  syncPayments: async () => {
    const response = await axios.post(`${API_URL}/api/shopify/payments/sync`);
    return response.data;
  },
  getTransactionDetails: async (transactionId) => {
    const response = await axios.get(`${API_URL}/api/shopify/payments/transaction/${transactionId}`);
    return response.data;
  },

  // Error handling wrapper
  handleRequest: async (request) => {
    try {
      return await request();
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || 'An error occurred with the Shopify API');
      }
      throw error;
    }
  }
};

// Wrap all methods with error handling
Object.keys(shopifyApi).forEach(key => {
  if (typeof shopifyApi[key] === 'function' && key !== 'handleRequest') {
    const originalMethod = shopifyApi[key];
    shopifyApi[key] = (...args) => shopifyApi.handleRequest(() => originalMethod(...args));
  }
}); 